import type { PerspectiveCamera, Scene, SceneControl } from '@anov/3d-core'
import { Clock, use } from '@anov/3d-core'
import type { ControlThirdModule } from '../base'
import Player from './player'

/**
 * @class ThirdViewControl.ts - third view control module
 *
 * 贴地 (Third View) 控制模块
 */

class ThirdViewControl implements ControlThirdModule {
  scene: Scene
  camera: PerspectiveCamera
  sceneControl: SceneControl
  entitiesCharacter: Player[] = []

  constructor(camera: PerspectiveCamera, scene: Scene, sceneControl: SceneControl) {
    this.scene = scene
    this.camera = camera
    this.sceneControl = sceneControl

    this.initialize()
  }

  initialize() {
    this.entitiesCharacter.push(
      new Player({
        camera: this.camera,
        scene: this.scene,
        sceneControl: this.sceneControl,
      }),
    )

    const clock = new Clock()

    use.useframe(this.sceneControl, () => {
      const deltaT = clock.getDelta()

      this.entitiesCharacter.forEach((item, _, array) => {
        item.update(deltaT, {
          entities: array,
        })
      })
    })
  }
}

export default ThirdViewControl